export const USER_INFO = "user_info"; //同步用户信息
export const SAVE_TOTAL_SACORE = "save_tatal_score"; //修改综合分
export const RESET_USER_INFO = "reset_user_info"; //退出登录重置用户信息
export const INIT_USER_INFO = "init_user_info"; //初始化用户信息
export const USER_COLLECT_SCHOOL = "user_collect_school"; //用户收藏院校
export const REMOVE_COLLECT_SCHOOL = "remove_collect_school"; //删除用户收藏院校
export const REMOVE_COLLECT_SCHOOL_ALL = "remove_collect_school_all";// 批量删除选中院校
export const SCHOOL_FINDER_DATA = "school_finder_data"; //院校查询
export const SCHOOL_RECOMMEND_DATA = "school_recommend_data"; //院校查询
export const INIT_SCHOOL__DATA = "init_school_data"; //清空院校查询及推荐数据